import { Component, OnInit } from '@angular/core';
import * as echarts from 'echarts';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { createChartSingle, formatYear } from 'src/app/shared/commen-function-file';
import { PdfDownloadService } from 'src/app/pdf-download-service.service';
import html2canvas from 'html2canvas';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';
interface ExperienceUser {
  ExpInYear: number;
  count: number;
}

interface Month {
  key: number;
  name: string;
}

@Component({
  selector: 'app-attrition-score-exp-wise',
  templateUrl: './attrition-score-exp-wise.component.html',
  styleUrls: ['./attrition-score-exp-wise.component.scss'],
})
export class AttritionScoreExpWiseComponent implements OnInit {

  isUserEmployee: boolean = false;

  graphType: string = 'bar';  // Default chart type

  pmsYears: any = [];
  loggedInCompanyFiscalyear: any;
  setupGradeBrand: any;
  setUpyearRange: any;
  loggedInUserEmpCode: any | null;
  buttonColorName: any | null;
  subModuleButtonColor: any | null;
  loggedInUserId: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserRole: any;
  loggedInUserRoles: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoleIsEmployee: any;
  loggedInUserCompanyID: any;

  selectedYearForCompetency: any = null;
  selectedYear: any = null;
  fromYear: any;
  toYear: any;
  arrAllMonths: any = [];
  selectedMonth: any;

  previousMonthsCountJanDec: any;
  previousMonthsCountAprilMarch: any;

  arrUserIds: any = [];
  intHODempCode: any;
  arrHODByExitedUserList: any = [];
  arrExitedUserIds: any = [];
  arrHODByUserList: any = [];
  getTeamLists: any = [];
  userIdsList: any = [];
  kpiPayloadListExitedUser: any;
  loggedInUserName: any;


  // For ESS Score Wise
  essYear = '';
  essMonth?: number;

  // For PMS Score Range
  pmsYear = '';
  pmsMonth?: number;

  // For Potential Score Range
  potentialYear = '';
  potentialMonth?: number;

  // For Experience in Company
  experienceYear = '';
  experienceMonth?: number;

  // For 9 Box Category
  nineBoxYear = '';
  nineBoxMonth?: number;

  constructor(private encryptionService: EncryptionService,
    private httpService: HttpService, private config: Config,
    public sharedService: SharedService, private PdfDownload: PdfDownloadService
  ) { }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.intHODempCode = sessionStorage.getItem('empCode');


    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }

    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    // this.updateYearControl(this.loggedInCompanyFiscalyear);
    // this.getAllFunctionsByYearRangeReport();
    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == "Employee") {
          this.loggedInUserRoleIsEmployee = true
        }
      }
    }
    this.getpmsyearlist();
  }

  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      // this.pmsYears = formatYearRanges(data?.data?.yearRanges);
      this.pmsYears = formatYear(data?.data?.yearRanges, this.loggedInCompanyFiscalyear);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
      this.setSelectedYear(yearValue);



    });
  }

  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYearForCompetency = selectedYearObj?.year;
      this.selectedYearForCompetency1 = selectedYearObj?.year;
      this.selectedYearForCompetency2 = selectedYearObj?.year;
      this.selectedYearForCompetency3 = selectedYearObj?.year;
      this.selectedYearForCompetency4 = selectedYearObj?.year;
      let test = selectedYearObj?.year.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];

      if (this.intHODempCode != 'null') {
        console.log("hod");
        
        this.fetchHODByUserList('');
      } else {
        // this.getMonths(this.fromYear, this.toYear, '');
        this.getMonths(this.fromYear, this.toYear, 'firstOne');
        this.getMonths(this.fromYear, this.toYear, 'first');
        this.getMonths(this.fromYear, this.toYear, 'second');
        this.getMonths(this.fromYear, this.toYear, 'three');
        this.getMonths(this.fromYear, this.toYear, 'four');

      }
    }
  }




  selectedYearForCompetency1: any;
  selectedYearForCompetency2: any;
  selectedYearForCompetency3: any;
  selectedYearForCompetency4: any;

  onYearChange(year: any, graphNo: any) {
    this.taskFromDate = null;
    this.taskToDate = null;


    if (graphNo == 'first') {
      this.selectedYearForCompetency1 = year;
    }
    if (graphNo == 'second') {
      this.selectedYearForCompetency2 = year;
    }
    if (graphNo == 'three') {
      this.selectedYearForCompetency3 = year;
    }
    if (graphNo == 'four') {
      this.selectedYearForCompetency4 = year;
    }
    else if (graphNo == 'firstOne') {
      this.selectedYearForCompetency = year;
    } else { }


    if (this.intHODempCode != 'null') {

      this.fetchHODByUserList(graphNo);
    } else {
      this.getMonths(this.fromYear, this.toYear, graphNo);
    }
  }


  fiscalYearMonthsAprilMarch = [
    { key: 4, name: "April" },
    { key: 5, name: "May" },
    { key: 6, name: "June" },
    { key: 7, name: "July" },
    { key: 8, name: "August" },
    { key: 9, name: "September" },
    { key: 10, name: "October" },
    { key: 11, name: "November" },
    { key: 12, name: "December" },
    { key: 1, name: "January" },
    { key: 2, name: "February" },
    { key: 3, name: "March" },
  ];

  fiscalYearMonthsJanDec = [
    { key: 1, name: "January" },
    { key: 2, name: "February" },
    { key: 3, name: "March" },
    { key: 4, name: "April" },
    { key: 5, name: "May" },
    { key: 6, name: "June" },
    { key: 7, name: "July" },
    { key: 8, name: "August" },
    { key: 9, name: "September" },
    { key: 10, name: "October" },
    { key: 11, name: "November" },
    { key: 12, name: "December" },
  ];

  selectedMonthName: any;


  getMonths(fromYear: any, toYear: any, graphNo: any) {
    this.arrAllMonths = (this.loggedInCompanyFiscalyear === 'Jan_Dec')
      ? this.fiscalYearMonthsJanDec
      : this.fiscalYearMonthsAprilMarch;
    // console.log('arrAllMonths:', this.arrAllMonths);

    const currentMonth = new Date().getMonth() + 1;
console.log(currentMonth,"----------------------------------");

    switch (graphNo) {
      case 'firstOne':
        this.selectedMonth = currentMonth;
        break;
      case 'first':
        this.selectedMonth1 = currentMonth;
        break;
      case 'second':
        this.selectedMonth2 = currentMonth;
        break;
      case 'three':
        this.selectedMonth3 = currentMonth;
        break;
      case 'four':
        this.selectedMonth4 = currentMonth;
        break;
      default:
        this.selectedMonth = currentMonth;
    }

    const selectedMonthObj = this.fiscalYearMonthsJanDec.find(
      (m: Month) => m.key === currentMonth
    );
    this.selectedMonthName = selectedMonthObj ? selectedMonthObj.name : null;

    this.previousMonthsCountAprilMarch = this.fiscalYearMonthsAprilMarch.findIndex(m => m.key === currentMonth) + 1;
    this.previousMonthsCountJanDec = currentMonth;

    switch (graphNo) {
      case 'first':
        this.fetchKpiScore();
        break;
      case 'second':
        this.fetchPotentialBuckets();
        break;
      case 'three':
        this.fetchYearBuckets();
        break;
      case 'four':
        this.fetchNineBoxAttrition();
        break;
      default:
        this.fetchYearBuckets();
        this.fetchPotentialBuckets();
        this.fetchKpiScore();
        this.fetchNineBoxAttrition();
    }
  }


  selectedMonth1: any;
  selectedMonth2: any;
  selectedMonth3: any;
  selectedMonth4: any;

  selectedMonthName1: any;
  selectedMonthName2: any;
  selectedMonthName3: any;
  selectedMonthName4: any;

  previousMonthsCountAprilMarch1: any;
  previousMonthsCountAprilMarch2: any;
  previousMonthsCountAprilMarch3: any;
  previousMonthsCountAprilMarch4: any;

  previousMonthsCountJanDec1: any;
  previousMonthsCountJanDec2: any;
  previousMonthsCountJanDec3: any;
  previousMonthsCountJanDec4: any;



  onMonthChange(event: any, graphNo: string) {
    const selectedMonthKey = event.value;

    let selectedMonthName = '';
    let prevCountApril = 0;
    let prevCountJan = 0;

    const selectedMonthObj = this.fiscalYearMonthsJanDec.find(m => m.key === selectedMonthKey);
    selectedMonthName = selectedMonthObj ? selectedMonthObj.name : '';


    const indexAprilMarch = this.fiscalYearMonthsAprilMarch.findIndex(m => m.key === selectedMonthKey);
    prevCountApril = indexAprilMarch + 1;

    const indexJanDec = this.fiscalYearMonthsJanDec.findIndex(m => m.key === selectedMonthKey);
    prevCountJan = selectedMonthKey;

    switch (graphNo) {
      case 'first':
        this.selectedMonth1 = selectedMonthKey;
        this.selectedMonthName1 = selectedMonthName;
        this.previousMonthsCountAprilMarch1 = prevCountApril;
        this.previousMonthsCountJanDec1 = prevCountJan;
        this.fetchKpiScore();
        this.fetchPmsScoreData();
        break;

      case 'second':
        this.selectedMonth2 = selectedMonthKey;
        this.selectedMonthName2 = selectedMonthName;
        this.previousMonthsCountAprilMarch2 = prevCountApril;
        this.previousMonthsCountJanDec2 = prevCountJan;
        this.fetchPotentialBuckets();
        break;

      case 'three':
        this.selectedMonth3 = selectedMonthKey;
        this.selectedMonthName3 = selectedMonthName;
        this.previousMonthsCountAprilMarch3 = prevCountApril;
        this.previousMonthsCountJanDec3 = prevCountJan;
        this.fetchYearBuckets();

        break;

      case 'four':
        this.selectedMonth4 = selectedMonthKey;
        this.selectedMonthName4 = selectedMonthName;
        this.previousMonthsCountAprilMarch4 = prevCountApril;
        this.previousMonthsCountJanDec4 = prevCountJan;
        this.fetchNineBoxAttrition();
        break;

      case 'firstOne':
        this.selectedMonth = selectedMonthKey;
        this.selectedMonthName = selectedMonthName;
        this.previousMonthsCountAprilMarch = prevCountApril;
        this.previousMonthsCountJanDec = prevCountJan;

        break;

      default:
        break;
    }
  }

  fetchHODByUserList(graphNo: string) {
    let selectedYear: string;


    switch (graphNo) {
      case 'firstOne':
        selectedYear = this.selectedYearForCompetency;
        this.getMonths(this.fromYear, this.toYear, graphNo);
        break;
      case 'first':
        selectedYear = this.selectedYearForCompetency1;
        this.getMonths(this.fromYear, this.toYear, graphNo);
        break;
      case 'second':
        selectedYear = this.selectedYearForCompetency2;
        this.getMonths(this.fromYear, this.toYear, graphNo);
        break;
      case 'three':
        selectedYear = this.selectedYearForCompetency3;
        this.getMonths(this.fromYear, this.toYear, graphNo);
        break;
      case 'four':
        selectedYear = this.selectedYearForCompetency4;
        this.getMonths(this.fromYear, this.toYear, graphNo);
        break;
      default:
        // selectedYear = this.selectedYearForCompetency;
        // this.getMonths(this.fromYear, this.toYear, graphNo);
        ['first', 'second', 'three', 'four', 'five', ''].forEach(gNo => {
          this.getMonths(this.fromYear, this.toYear, gNo);
        });
        selectedYear = this.selectedYearForCompetency;
    }

    let apiUrl = `${this.config.fetchHODByUserList}?companyId=${this.loggedInUserCompanyID}&hodCode=${this.intHODempCode}&yearRange=${selectedYear}&fiscalType=${this.loggedInCompanyFiscalyear}`;
    this.httpService.callGetService(apiUrl).subscribe((resp: any) => {
      this.arrUserIds = [];
      const arrHODByUserList = resp?.data?.data?.filter((emp: any) => emp?.userId != this.loggedInUserId);
      this.arrHODByUserList = arrHODByUserList;
      arrHODByUserList?.map((emp: any) => this.arrUserIds.push(emp?.userId));


      if (this.loggedInUserRole == 'HOD') {
        if (graphNo == 'first' || graphNo == '') {
          this.fetchKpiScoresForUsers(this.arrUserIds.map(String));
        }

      }
    });

    let url = `${this.config.getEmployeeUnderHodExit}?companyId=${this.loggedInUserCompanyID}&hodCode=${this.intHODempCode}&yearRange=${selectedYear}&fiscalType=${this.loggedInCompanyFiscalyear}`;
    this.httpService.callGetService(url).subscribe((resp: any) => {
      const arrHODByUserList = resp?.data?.data?.filter((emp: any) => emp?.userId != this.loggedInUserId);

      this.arrHODByExitedUserList = arrHODByUserList;
      arrHODByUserList?.map((emp: any) => this.arrExitedUserIds?.push(emp?.userId));

      if (this.loggedInUserRole == 'HOD') {
        if (this.arrExitedUserIds.length > 0) {
          if (graphNo == 'first' || graphNo == '') {
            this.fetchKpiScoresForExitedUsers(this.arrExitedUserIds.map(String));
          }

        }

      }
      if (graphNo == 'four') {
        this.fetchNineBoxAttrition();
      }


      if (graphNo == '') {
        this.fetchNineBoxAttrition();
      }

    });
  }


  // Fetch KPI Score
  fetchKpiScore(): void {
    console.log("Fetching KPI Score for year:", this.selectedYearForCompetency);

    const employeeRequest = {
      companyId: this.loggedInUserCompanyID
    };

    this.httpService.callPostService(this.config.getAllEmployeeDropdownByCompanyID, employeeRequest)
      .subscribe((employeeData: any) => {
        const users = employeeData?.data?.users || [];

        this.userIdsList = [];
        this.getTeamLists = [];

        users.forEach((user: any) => {
          this.userIdsList.push(user.id);

          this.getTeamLists.push({
            id: user.id,
            name: `${user.firstName} ${user.lastName}`,
            empCode: user.empCode
          });
        });

        if (this.userIdsList.length > 0) {
          if (this.loggedInUserRole != 'HOD') {
            this.fetchKpiScoresForUsers(this.userIdsList.map(String));
          }

        } else {
          console.warn('No users found to fetch KPI scores.');
        }
      });
  }
  kpiPayloadList: any
  private isFetchingBuckets = false; // Add this flag

  // For Active User : kpi score
  private fetchKpiScoresForUsers(userIds: string[]): void {
    console.log("----------------------d-fetchKpiScoresForUsers")
    let selectedYearObj = this.selectedYearForCompetency1.split('-');

    let fromYear = selectedYearObj[0];
    let toYear = selectedYearObj[1];

    const kpiRequest = {
      compId: this.loggedInUserCompanyID,
      fromYear: Number(fromYear),
      toYear: Number(toYear),
      month: [],
      search: null,
      userId: userIds
    };

    this.httpService.callPostService(this.config.getMonthYTDReport, kpiRequest)
      .subscribe((kpiData: any) => {
        if (kpiData?.status && kpiData?.data?.employeeResponse?.length) {
          this.kpiPayloadList = []; // Reset before push

          kpiData.data.employeeResponse.forEach((emp: any) => {

            if (emp.ytd) {
              //  this.KPIPayload = {
              //   userId: emp.employeeId,
              //   kpiScore: emp.ytd
              // };
              // console.log("KPI Payload:", this.KPIPayload);
              this.kpiPayloadList.push({
                userId: emp.employeeId,
                kpiScore: Number(emp.ytd)
              });
              // this.fetchPerformanceBuckets();
              if (!this.isFetchingBuckets && this.kpiPayloadList.length > 0) {

                this.isFetchingBuckets = true; // Set flag to true

                this.fetchPerformanceBuckets();
              }
            }
          });
        } else {
          console.warn('No KPI data found.');
        }
      });
  }


  //For Exited User : kpi score
  private fetchKpiScoresForExitedUsers(userIds: string[]): void {
    console.log("----------------fetchKpiScoresForExitedUsers");

    let selectedYearObj = this.selectedYearForCompetency1.split('-');

    let fromYear = selectedYearObj[0];
    let toYear = selectedYearObj[1];

    const kpiRequest = {
      compId: this.loggedInUserCompanyID,
      fromYear: Number(fromYear),
      toYear: Number(toYear),
      month: [],
      search: null,
      userId: userIds
    };

    this.httpService.callPostService(this.config.getMonthYTDReport, kpiRequest)
      .subscribe((kpiData: any) => {

        console.log("kpiData------------------", kpiData);


        if (kpiData?.status && kpiData?.data?.employeeResponse?.length) {
          this.kpiPayloadListExitedUser = []; // Reset before push

          kpiData.data.employeeResponse.forEach((emp: any) => {

            if (emp.ytd) {

              this.kpiPayloadListExitedUser.push({
                userId: emp.employeeId,
                kpiScore: Number(emp.ytd)
              });


            }
            this.pmsScoreGraph('bar');
          });
        } else {
          console.warn('No KPI data found.');
        }
      });
  }


  switchGraphType(type: string) {
    this.graphType = type;
  }

  selectGraphType: any = 'bar';
  selectedFromDated: any;
  selectedtoDated: any;
  taskFromDate: any;
  taskToDate: any;

  formatDateToISO(date: Date): string {
    const pad = (num: number): string => String(num).padStart(2, '0');
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1); // Months are zero-based
    const day = pad(date.getDate());

    return `${year}-${month}-${day}`;
  }
  processFirstGraphDateRange(): void {
    if (this.taskFromDate && this.taskToDate) {
      const fromDate = new Date(this.taskFromDate);
      const toDate = new Date(this.taskToDate);

      fromDate.setHours(0, 0, 0, 0);  // Start of the day
      toDate.setHours(23, 59, 59, 999); // End of the day

      const formattedFromDate = this.formatDateToISO(fromDate) + "T00:00:00";
      const formattedToDate = this.formatDateToISO(toDate) + "T23:59:59";

      this.selectedFromDated = formattedFromDate;
      this.selectedtoDated = formattedToDate;



    } else {
      console.log('No filtering applied for Graph 1, returning all data');
    }
  }
  downloadChartAsPDF(type: string, graphNo: string): void {
    const idMapping: { [key: string]: () => string } = {
      'PMS Score Range': () => this.isPmsScoreRangeTable ? 'table-PMS-Score-Range-data' : 'pms-score-range-chart',
      'Experience in Company': () => this.isExperienceAttritionRateTable ? 'table-Exp-Attrition-data' : 'experience-attrition-chart',
      'potential score range': () => this.isPotentialScoreRangeTable ? 'table-Potential-Score-Range-data' : 'potential-score-range-chart',
      'ESS Score Wise': () => '', // Define if needed
      'nine box category': () => this.isNineBoxAttritionRateTable ? 'table-NineBox-Attrition-data' : 'ninebox-attrition-chart',
    };

    const yearMap: { [key: string]: string } = {
      first: this.selectedYearForCompetency1,
      second: this.selectedYearForCompetency2,
      three: this.selectedYearForCompetency3,
      four: this.selectedYearForCompetency4,
      firstOne: this.selectedYearForCompetency
    };

    const monthMap: { [key: string]: string } = {
      first: this.selectedMonthName1,
      // second: this.selectedMonthName2,
      three: this.selectedMonthName3,
      four: this.selectedMonthName4,
      firstOne: this.selectedMonthName,
    };

    const idSelector = idMapping[type]?.() || 'default-chart-id';
    const element = document.getElementById(idSelector);

    if (!element) {
      console.error('Chart element not found:', idSelector);
      return;
    }

    const selectedYearRaw = yearMap[graphNo] || this.selectedYearForCompetency;
    const selectedMonthRaw = monthMap[graphNo] || this.selectedMonthName;
    console.log(selectedMonthRaw, "selectedMonthRaw")
    const selectedYear = this.loggedInCompanyFiscalyear === 'Jan_Dec'
    ? `FY ${selectedYearRaw.split('-')[0]}`
    : `FY ${selectedYearRaw.split('-')[0]}-${selectedYearRaw.split('-')[1]?.slice(-2)}`;

    const normalizedType = type.trim().toLowerCase();
    const excludedTypes = ['nine box category', 'potential score range'];
    const month = excludedTypes.includes(normalizedType) ? '' : selectedMonthRaw;

    this.PdfDownload.downloadPDFMonthwise(idSelector, type, selectedYear, month);
  }

  // -------------------------- Experience in Company -----------------------------
  public isExperienceAttritionRateIcon: string = 'bar';
  public isExperienceAttritionRateTable: boolean = false;
  public isExperienceAttritionTableGraph: any[] = [];
  public selectGraphExperienceAttritionType: any = 'bar';
  public selectGraphExperienceType: any = 'bar';
  public isExperienceTableGraph: any = [];
  public experienceAttrition: any;
  public yearBuckets: any;



  experienceAttritionRate(graphType: any) {
    this.selectGraphExperienceAttritionType = graphType;
    this.isExperienceAttritionRateIcon = graphType;
    this.isExperienceAttritionRateTable = false;
    this.experienceAttritionGraph(this.selectGraphExperienceAttritionType);
  }

  experienceAttritionRateTable() {
    this.selectGraphExperienceType = 'table';
    this.isExperienceAttritionRateIcon = '';
    this.isExperienceAttritionRateTable = true;
  }

  experienceAttritionLineGraph(data: any, idSelector: any, graphType: any): void {
    createChartSingle(idSelector, 'line', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }

  experienceAttritionBarGraph(data: any, idSelector: any, graphType: any): void {
    createChartSingle(idSelector, 'bar', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }

  fetchYearBuckets(): void {
    console.log("ddddddddddddddddddddddddddddddddddddd------------", this.selectedYearForCompetency3);

    this.httpService.callGetService(`${this.config.yearBucketUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForCompetency3}`)
      .subscribe({
        next: (data: any) => {
          this.yearBuckets = data.data;
          console.log('yearBuckets', this.yearBuckets);
          this.fetchExperienceAttrition();
        },
        error: (err) => {
          console.error('Error fetching year buckets:', err);
        }
      });
  }
  fetchExperienceAttrition(): void {

    const userHodExitedIdsString: string = this.arrExitedUserIds.join(',') || ''; //for hod
    const userIdsString: string = this.arrUserIds.join(',') || '';
    console.log("userHodExitedIdsString", userHodExitedIdsString);

    if (this.loggedInUserRole == 'HOD' && userHodExitedIdsString == '') {

      this.experienceAttritionGraph('bar');
      return;
    }
    const apiUrl = (userHodExitedIdsString) ? `${this.config.attritionExperienceDataUrl}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency3}&month=${this.selectedMonth3}&userHodExitedIds=${userHodExitedIdsString}` : `${this.config.attritionExperienceDataUrl}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency3}&month=${this.selectedMonth3}`
    this.httpService.callGetService(apiUrl)
      .subscribe({
        next: (data: any) => {
          this.experienceAttrition = data;
          console.log('Experience Attrition:', this.experienceAttrition);
          this.experienceAttritionGraph('bar');
        },
        error: (err) => {
          console.error('Error fetching experience attrition:', err);
        }
      });
  }

  experienceAttritionGraph(graphType: string) {
    console.log("Experience Data:", this.experienceAttrition);

    if (!this.experienceAttrition?.data?.length || !this.yearBuckets?.length) {
      console.warn("Data Not Found: Experience data or Experience Buckets are missing");
      this.isExperienceTableGraph = [];
      const chartElement = document.getElementById('experience-attrition-chart') as HTMLDivElement;
      if (chartElement) {
        echarts.init(chartElement).clear();
      }
      return;
    }

    const experienceData = this.experienceAttrition.data[0];

    const exitUsersMap = new Map<number, number>();
    const activeUsersMap = new Map<number, number>();
    const existingUsersMap = new Map<number, number>();

    experienceData.AllExitInBetweenUser?.forEach((user: ExperienceUser) => {
      const { ExpInYear, count } = user;
      exitUsersMap.set(ExpInYear, (exitUsersMap.get(ExpInYear) || 0) + count);
    });
    experienceData.AllActiveUsers?.forEach((user: ExperienceUser) => {
      const { ExpInYear, count } = user;
      activeUsersMap.set(ExpInYear, (activeUsersMap.get(ExpInYear) || 0) + count);
    });

    experienceData.AllExistsUsers?.forEach((user: ExperienceUser) => {
      const { ExpInYear, count } = user;
      existingUsersMap.set(ExpInYear, (existingUsersMap.get(ExpInYear) || 0) + count);
    });


    const finalActiveUsersMap = new Map<number, number>();
    activeUsersMap.forEach((count, exp) => {
      finalActiveUsersMap.set(exp, count - (existingUsersMap.get(exp) || 0));
    });

    // const previousMonthsCount =
    //   this.loggedInCompanyFiscalyear === "Jan_Dec"
    //     ? this.previousMonthsCountJanDec
    //     : this.previousMonthsCountAprilMarch;

    const month = this.selectedMonth3 || (new Date().getMonth() + 1);
    const selectedMonthKey = month || (new Date().getMonth() + 1);

    const previousMonthsCountJanDec = selectedMonthKey;
    const previousMonthsCountAprilMarch = this.fiscalYearMonthsAprilMarch.findIndex(m => m.key === selectedMonthKey) + 1;

    const previousMonthsCount =
      this.loggedInCompanyFiscalyear === "Jan_Dec"
        ? previousMonthsCountJanDec
        : previousMonthsCountAprilMarch;

    console.log("previousMonthsCount as per loggedInCompanyFiscalyear", previousMonthsCount);

    const lastBucketMax = this.yearBuckets[this.yearBuckets.length - 1].yearBucketMax;

    const bucketRanges = [...this.yearBuckets.map((bucket: any) => ({
      label: `${bucket.yearBucketLow}-${bucket.yearBucketMax}`,
      min: bucket.yearBucketLow,
      max: bucket.yearBucketMax
    }))];

    // Add final "X+" bucket
    bucketRanges.push({
      label: `${lastBucketMax}+`,
      min: lastBucketMax,
      max: Infinity
    });

    const transformedData = bucketRanges.map(({ label, min, max }) => {
      let exitCount = 0;
      let activeCount = 0;

      exitUsersMap.forEach((count, exp) => {
        if (exp >= min && exp < max) exitCount += count;
      });

      finalActiveUsersMap.forEach((count, exp) => {
        if (exp >= min && exp < max) activeCount += count;
      });

      // const attritionPercentage = activeCount > 0
      //   ? ((exitCount / activeCount) * 100).toFixed(2)
      //   : '0.00';
      const totalUsers = activeCount + exitCount;
      const attritionPercentage = totalUsers > 0
        ? ((exitCount / totalUsers) * 100).toFixed(2)
        : '0.00';

      const annualizedAttrition = ((+attritionPercentage * 12) / previousMonthsCount).toFixed(2);

      return graphType === 'pie'
        ? {
          name: label,
          value: exitCount,
          attritionPercentage,
          annualizedAttrition
        }
        : {
          xAxisValueData: label,
          seriesValueOneData: exitCount,
          seriesValueTwoData: +attritionPercentage,
          seriesValueThreeData: +annualizedAttrition,
          xAxisName: 'Years of Experience',
          yAxisName: 'Employee Count',
          seriesLabelOne: 'Employee Count',
          seriesLabelTwo: 'Attrition %',
          seriesLabelThree: 'Annualized Attrition %'
        };
    });

    console.log("Transformed Experience Data:", transformedData);
    this.isExperienceTableGraph = transformedData;

    if (graphType === 'pie') {
      const pieChartOptions = this.attritionPieChartOptions(transformedData);
      echarts.init(document.getElementById('experience-attrition-chart') as HTMLDivElement).setOption(pieChartOptions);
    } else {
      const seriesLabels = { xAxisName: 'Experience Buckets', yAxisName: 'Count' };
      const graphFunctions: Record<string, Function> = {
        bar: this.experienceAttritionBarGraph,
        line: this.experienceAttritionLineGraph
      };

      const renderGraph = graphFunctions[graphType];
      if (renderGraph) {
        renderGraph.call(this, transformedData, 'experience-attrition-chart', 'single', seriesLabels);
      }
    }
  }


  // --------------------------PMS Score Range-----------------------------
  public isPmsScoreRangeIcon: string = 'bar';
  public isPmsScoreRangeTable: boolean = false;
  public isPmsScoreTableGraph: any[] = [];
  public selectGraphPmsScoreType: any = 'bar';
  public isPmsTableGraph: any = [];
  public pmsScoreData: any;
  public performanceBuckets: any;
  fetchPerformanceBuckets(): void {
    this.httpService.callGetService(`${this.config.performanceBucketUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForCompetency1}`)
      .subscribe({
        next: (data: any) => {
          this.performanceBuckets = data.data;

          this.calculateKpiBucketCounts();
          this.isFetchingBuckets = false; // Reset flag after everything is done
        },
        error: (err) => {
          console.error('Error fetching performance buckets:', err);
          this.isFetchingBuckets = false; // Reset on error too

        }
      });
  }
  private activeKpiCounts: number[] = [];

  activeUserForKPIScore: any;
  private calculateKpiBucketCounts(): void {
    if (!this.kpiPayloadList?.length || !this.performanceBuckets?.length) {
      console.warn("Missing KPI scores or bucket data");
      return;
    }

    const buckets = [...this.performanceBuckets];
    const lastBucket = buckets[buckets.length - 1];

    buckets.push({
      lowerEnd: lastBucket.upperEnd,
      upperEnd: Number.MAX_SAFE_INTEGER
    });

    const bucketSummary = buckets.map((bucket, index) => ({
      range: index === buckets.length - 1
        ? `${bucket.lowerEnd}+`
        : `${bucket.lowerEnd}-${bucket.upperEnd}`,
      lowerEnd: bucket.lowerEnd,
      upperEnd: bucket.upperEnd,
      count: 0
    }));

    // Count KPI scores in each bucket
    this.kpiPayloadList.forEach((emp: any) => {
      const score = emp.kpiScore;
      const bucket = bucketSummary.find(b => score >= b.lowerEnd && score < b.upperEnd);
      if (bucket) bucket.count += 1;
    });

    this.activeUserForKPIScore = bucketSummary; // Store for graph/table usage

    this.activeKpiCounts = bucketSummary.map(bucket => bucket.count);


    this.fetchPmsScoreData();
  }


  pmsScoreDataData: any
  fetchPmsScoreData(): void {
    console.log(this.loggedInUserRole);

    const userHodExitedIdsString: string = this.arrExitedUserIds.join(',') || ''; //for hod
    const userIdsString: string = this.arrUserIds.join(',') || '';
    console.log("-**********************userHodExitedIdsString---", userHodExitedIdsString)
    if (this.loggedInUserRole == 'HOD' && userHodExitedIdsString == '') {
      this.pmsScoreGraph('bar');
      return;
    }

    console.log("-------------------userHodExitedIdsString", userHodExitedIdsString);


    const apiUrl = (userHodExitedIdsString) ?
      `${this.config.pmsScoreDataUrl}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency1}&month=${this.selectedMonth1}&userHodExitedIds=${userHodExitedIdsString}` :
      `${this.config.pmsScoreDataUrl}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency1}&month=${this.selectedMonth1}`
    this.httpService.callGetService(apiUrl)
      .subscribe({
        next: (data: any) => {
          this.pmsScoreData = data;
          if (this.pmsScoreData.data.length > 0) {
            this.pmsScoreDataData = data.data;

            const userIds = this.pmsScoreDataData.map((item: any) => item.User_id);

            this.fetchKpiScoresForExitedUsers(userIds.map(String));
          } else {
            this.kpiPayloadListExitedUser = [];
            this.pmsScoreGraph('bar');
          }



          // this.pmsScoreGraph('bar');
        },
        error: (err) => {
          console.error('Error fetching PMS Score Data:', err);
        }
      });
  }

  pmsScoreRange(graphType: any) {
    this.selectGraphPmsScoreType = graphType;
    this.isPmsScoreRangeIcon = graphType;
    this.isPmsScoreRangeTable = false;
    this.pmsScoreGraph(this.selectGraphPmsScoreType);
  }

  pmsScoreRangeTable() {
    this.selectGraphPmsScoreType = 'table';
    this.isPmsScoreRangeIcon = '';
    this.isPmsScoreRangeTable = true;
  }

  PMSScoreAttritionLineGraph(data: any, idSelector: any, graphType: any): void {
    createChartSingle(idSelector, 'line', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }

  PMSScoreAttritionBarGraph(data: any, idSelector: any, graphType: any): void {
    createChartSingle(idSelector, 'bar', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }
  pmsScoreGraph(graphType: string) {
    console.log("PMS Score Data:", this.kpiPayloadListExitedUser);

    if (!this.kpiPayloadListExitedUser?.length || !this.performanceBuckets?.length) {
      console.warn("Data Not Found: PMS Score data or Performance Buckets are missing");
      this.isPmsScoreTableGraph = [];

      const chartElement = document.getElementById('pms-score-range-chart') as HTMLDivElement;
      if (chartElement) {
        echarts.init(chartElement).clear();
      }
      return;
    }

    // const previousMonthsCount =
    //   this.loggedInCompanyFiscalyear === "Jan_Dec"
    //     ? this.previousMonthsCountJanDec
    //     : this.previousMonthsCountAprilMarch;
    const month = this.selectedMonth1 || (new Date().getMonth() + 1);
    const selectedMonthKey = month || (new Date().getMonth() + 1);

    const previousMonthsCountJanDec = selectedMonthKey;
    const previousMonthsCountAprilMarch = this.fiscalYearMonthsAprilMarch.findIndex(m => m.key === selectedMonthKey) + 1;

    const previousMonthsCount =
      this.loggedInCompanyFiscalyear === "Jan_Dec"
        ? previousMonthsCountJanDec
        : previousMonthsCountAprilMarch;

    console.log("previousMonthsCount as per loggedInCompanyFiscalyear", previousMonthsCount);

    // Extend bucket list with a synthetic upper bucket
    const buckets = [...this.performanceBuckets];
    const lastBucket = buckets[buckets.length - 1];
    buckets.push({
      lowerEnd: lastBucket.upperEnd,
      upperEnd: Number.MAX_SAFE_INTEGER
    });

    const performanceBucketRange = buckets.map((bucket: any, index: number) => {
      const isLast = index === buckets.length - 1;
      return {
        range: isLast ? `${bucket.lowerEnd}+` : `${bucket.lowerEnd}-${bucket.upperEnd}`,
        lowerEnd: bucket.lowerEnd,
        upperEnd: bucket.upperEnd,
        count: 0
      };
    });

    // Categorize PMS Score Data into buckets
    this.kpiPayloadListExitedUser.forEach((score: any) => {
      const kpiScore = score.kpiScore;
      const bucket = performanceBucketRange.find((b: any) =>
        kpiScore >= b.lowerEnd && kpiScore < b.upperEnd
      );
      if (bucket) {
        bucket.count += 1;
      }

    });


    let transformedData: any[] = [];


    if (graphType === 'pie') {
      transformedData = performanceBucketRange.map((bucket: any) => {
        // if 0 then exited +1 
        //if not 0 then (active + exited )*12

        // const activeUsers = (this.activeUserForKPIScore.count + bucket.count) || (bucket.count);
        // const prevMonthsCount = previousMonthsCount || 1;
        const activeUser = this.activeUserForKPIScore.find((kpiScore: any) => kpiScore.range === bucket.range);
        const activeUserCount = activeUser?.count || 0;


        const activeUsers = parseInt(activeUserCount + bucket.count);
        const prevMonthsCount = previousMonthsCount || 1;

        // const attritionPercentage = parseFloat(((bucket.count / activeUsers) * 100).toFixed(2)) || 0;
        // const annualizedAttrition = parseFloat(((attritionPercentage * 12) / prevMonthsCount).toFixed(2)) || 0;
        const attritionPercentage = activeUsers > 0
          ? parseFloat(((bucket.count / activeUsers) * 100).toFixed(2))
          : 0;

        const annualizedAttrition = attritionPercentage > 0
          ? parseFloat(((attritionPercentage * 12) / prevMonthsCount).toFixed(2))
          : 0;

        return {
          name: bucket.range,
          value: bucket.count,
          attritionPercentage,
          annualizedAttrition
        };
      });
    } else {

      transformedData = performanceBucketRange.map((bucket: any) => {
        // const { minRange, maxRange } = bucket;

        const activeUser = this.activeUserForKPIScore.find((kpiScore: any) => kpiScore.range === bucket.range);
        const activeUserCount = activeUser?.count || 0;


        const activeUsers = parseInt(activeUserCount + bucket.count);
        const prevMonthsCount = previousMonthsCount || 1;

        // const attritionPercentage = parseFloat(((bucket.count / activeUsers) * 100).toFixed(2));

        // const annualizedAttrition = parseFloat(((attritionPercentage * 12) / prevMonthsCount).toFixed(2));


        const attritionPercentage =
          activeUsers > 0
            ? parseFloat(((bucket.count / activeUsers) * 100).toFixed(2))
            : 0;

        const annualizedAttrition =
          attritionPercentage > 0
            ? parseFloat(((attritionPercentage * 12) / prevMonthsCount).toFixed(2))
            : 0;
        return {
          xAxisValueData: bucket.range,
          seriesValueOneData: bucket.count,
          seriesValueTwoData: attritionPercentage,
          seriesValueThreeData: annualizedAttrition,
          xAxisName: 'Performance Score Range',
          yAxisName: 'User Count',
          seriesLabelOne: 'Users Count',
          seriesLabelTwo: 'Attrition %',
          seriesLabelThree: 'Annualized Attrition %'
        };
      });
    }


    console.log("Transformed PMS Score Data:", transformedData);
    this.isPmsScoreTableGraph = transformedData;

    if (graphType === 'pie') {
      const pieChartOptions = this.attritionPieChartOptions(transformedData);
      echarts.init(document.getElementById('pms-score-range-chart') as HTMLDivElement).setOption(pieChartOptions);
    } else {
      const seriesLabels = {
        xAxisName: 'Performance Score',
        yAxisName: 'Attrition Count'
      };

      const graphFunctions: Record<string, Function> = {
        bar: this.PMSScoreAttritionBarGraph,
        line: this.PMSScoreAttritionLineGraph
      };

      const renderGraph = graphFunctions[graphType];
      if (renderGraph) {
        renderGraph.call(this, transformedData, 'pms-score-range-chart', 'single', seriesLabels);
      }
    }
  }

  // --------------------------Potential Score Range-----------------------------
  public isPotentialScoreRangeIcon: string = 'bar';
  public isPotentialScoreRangeTable: boolean = false;
  public isPotentialScoreTableGraph: any[] = [];
  public selectGraphPotentialScoreType: any = 'bar';
  public isPotentialTableGraph: any = [];
  public potentialScoreData: any;
  public potentialBuckets: any;

  fetchPotentialBuckets(): void {
    this.httpService.callGetService(`${this.config.potentialBucketUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForCompetency2}`)
      .subscribe({
        next: (data: any) => {
          this.potentialBuckets = data.data;
          console.log('Potential Buckets', this.potentialBuckets);
          this.fetchPotentialScoreData();
        },
        error: (err) => {
          console.error('Error fetching potential buckets:', err);
        }
      });
  }

  fetchPotentialScoreData(): void {


    const userHodExitedIdsString: string = this.arrExitedUserIds.join(',') || ''; //for hod

    if (this.loggedInUserRole == 'HOD' && userHodExitedIdsString == '') {
      this.potentialScoreGraph('bar');
      return;
    }

    const userIdsString: string = this.arrUserIds.join(',') || '';
    const apiUrl = (userHodExitedIdsString) ?
      `${this.config.potentialScoreDataUrl}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency2}&hodUserIds=${userIdsString}&userHodExitedIds=${userHodExitedIdsString}` :
      `${this.config.potentialScoreDataUrl}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency2}`
    this.httpService.callGetService(apiUrl)
      .subscribe({
        next: (data: any) => {
          this.potentialScoreData = data;
          this.potentialScoreGraph('bar');
        },
        error: (err) => {
          console.error('Error fetching Potential Score Data:', err);
        }
      });
  }

  potentialScoreRange(graphType: any) {
    this.selectGraphPotentialScoreType = graphType;
    this.isPotentialScoreRangeIcon = graphType;
    this.isPotentialScoreRangeTable = false;
    this.potentialScoreGraph(this.selectGraphPotentialScoreType);
  }

  potentialScoreRangeTable() {
    this.selectGraphPotentialScoreType = 'table';
    this.isPotentialScoreRangeIcon = '';
    this.isPotentialScoreRangeTable = true;
  }

  PotentialScoreAttritionLineGraph(data: any, idSelector: any, graphType: any): void {
    createChartSingle(idSelector, 'line', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }

  PotentialScoreAttritionBarGraph(data: any, idSelector: any, graphType: any): void {
    createChartSingle(idSelector, 'bar', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }

  potentialScoreGraph(graphType: string) {
    console.log("Potential Score Data:", this.potentialScoreData);

    if (!this.potentialScoreData?.data?.length || !this.potentialBuckets?.length) {
      console.warn("Data Not Found: Potential Score data or Potential Buckets are missing");
      this.isPotentialScoreTableGraph = [];
      const chartElement = document.getElementById('potential-score-range-chart') as HTMLDivElement;
      if (chartElement) {
        echarts.init(chartElement).clear();
      }
      return;
    }

    const activeUsers = this.potentialScoreData.data[0]?.AllActiveUsers || [];
    const existsUsers = this.potentialScoreData.data[0]?.AllExistsUsers || [];

    // Clone buckets and add synthetic upper bucket
    const buckets = [...this.potentialBuckets];
    const lastBucket = buckets[buckets.length - 1];
    buckets.push({
      lowerEnd: lastBucket.upperEnd,
      upperEnd: Number.MAX_SAFE_INTEGER
    });

    const potentialBucketRange = buckets.map((bucket: any, index: number) => {
      const isLast = index === buckets.length - 1;
      return {
        range: isLast ? `${bucket.lowerEnd}+` : `${bucket.lowerEnd}-${bucket.upperEnd}`,
        lowerEnd: bucket.lowerEnd,
        upperEnd: bucket.upperEnd,
        activeCount: 0,
        existsCount: 0
      };
    });

    // Populate bucket counts
    activeUsers.forEach((user: any) => {
      const bucket = potentialBucketRange.find((b: any) =>
        user.FinalScore >= b.lowerEnd && user.FinalScore < b.upperEnd
      );
      if (bucket) bucket.activeCount += 1;
    });

    existsUsers.forEach((user: any) => {
      const bucket = potentialBucketRange.find((b: any) =>
        user.FinalScore >= b.lowerEnd && user.FinalScore < b.upperEnd
      );
      if (bucket) bucket.existsCount += 1;
    });

    let transformedData: any[] = [];

    if (graphType === 'pie') {
      transformedData = potentialBucketRange.map((bucket: any) => ({
        name: bucket.range,
        value: bucket.existsCount,
        attritionPercentage: bucket.activeCount > 0
          ? ((bucket.existsCount / (bucket.activeCount + bucket.existsCount)) * 100).toFixed(2)
          : '0.00'
      }));
    } else {
      transformedData = potentialBucketRange.map((bucket: any) => ({
        xAxisValueData: bucket.range,
        seriesValueOneData: bucket.existsCount,
        seriesValueTwoData: bucket.activeCount > 0
          ? +((bucket.existsCount / (bucket.activeCount + bucket.existsCount)) * 100).toFixed(2)
          : 0,
        xAxisName: 'Potential Score Range',
        yAxisName: 'User Count',
        seriesLabelOne: 'Exists Users Count',
        seriesLabelTwo: 'Attrition %'
      }));
    }

    console.log("Transformed Potential Score Data:", transformedData);
    this.isPotentialScoreTableGraph = transformedData;

    if (graphType === 'pie') {
      const pieChartOptions = this.attritionPieChartOptions(transformedData);
      echarts.init(document.getElementById('potential-score-range-chart') as HTMLDivElement).setOption(pieChartOptions);
    } else {
      const seriesLabels = {
        xAxisName: 'Potential Score',
        yAxisName: 'Attrition Count'
      };

      const graphFunctions: Record<string, Function> = {
        bar: this.PotentialScoreAttritionBarGraph,
        line: this.PotentialScoreAttritionLineGraph
      };

      const renderGraph = graphFunctions[graphType];
      if (renderGraph) {
        renderGraph.call(this, transformedData, 'potential-score-range-chart', 'single', seriesLabels);
      }
    }
  }


  // --------------------------  9 Box Category-wise Attrition -----------------------------
  public isNineBoxAttritionRateIcon: string = 'bar';
  public isNineBoxAttritionRateTable: boolean = false;
  public isNineBoxTableGraph: any[] = [];
  public selectGraphNineBoxAttritionType: string = 'bar';
  public nineBoxAttrition: any;

  nineBoxAttritionRate(graphType: string) {
    this.selectGraphNineBoxAttritionType = graphType;
    this.isNineBoxAttritionRateIcon = graphType;
    this.isNineBoxAttritionRateTable = false;
    this.nineBoxAttritionGraph(graphType);
  }

  nineBoxAttritionRateTable() {
    this.selectGraphNineBoxAttritionType = 'table';
    this.isNineBoxAttritionRateIcon = '';
    this.isNineBoxAttritionRateTable = true;
  }
  nineBoxLineGraph(data: any, idSelector: any, graphType: any): void {
    createChartSingle(idSelector, 'line', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }

  nineBoxBarGraph(data: any, idSelector: any, graphType: any): void {
    createChartSingle(idSelector, 'bar', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }

  fetchNineBoxAttrition(): void {

    const userHodExitedIdsString: string = this.arrExitedUserIds.join(',') || ''; //for hod
    console.log("fetchNineBoxAttrition----------", this.arrExitedUserIds);

    if (this.loggedInUserRole == 'HOD' && userHodExitedIdsString == '') {
      this.nineBoxAttritionGraph('bar');
      return;
    }

    const userIdsString: string = this.arrUserIds.join(',') || '';
    const apiUrl = (userHodExitedIdsString) ?
      `${this.config.nineBoxCategoryDataUrl}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency4}&hodUserIds=${userIdsString}&userHodExitedIds=${userHodExitedIdsString}` :
      `${this.config.nineBoxCategoryDataUrl}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency4}`
    this.httpService.callGetService(apiUrl)
      .subscribe({
        next: (data: any) => {
          this.nineBoxAttrition = data;
          console.log('Nine Box Attrition:', this.nineBoxAttrition);
          this.nineBoxAttritionGraph('bar');
        },
        error: (err) => {
          console.error('Error fetching 9 Box attrition:', err);
        }
      });
  }

  nineBoxAttritionGraph(graphType: string): void {
    const chartElement = document.getElementById('ninebox-attrition-chart') as HTMLDivElement;

    if (!this.nineBoxAttrition?.data?.length) {
      console.warn("Data Not Found: 9 Box attrition data is missing");
      this.isNineBoxTableGraph = [];
      if (chartElement) echarts.init(chartElement).clear();
      return;
    }

    const attritionData = this.nineBoxAttrition.data[0];
    const allExitUser = attritionData.AllExitUser || [];
    const allActiveUsers = attritionData.AllActiveUsers || [];

    // Get all unique positioning keys
    const allPositionings = new Set([
      ...allExitUser.map((u: any) => u.positioning),
      ...allActiveUsers.map((u: any) => u.positioning),
    ]);

    const transformedData = Array.from(allPositionings).map((positioning) => {

      const exitCount = allExitUser
        .filter((u: any) => u.positioning === positioning)
        .reduce((sum: number, u: any) => sum + u.count, 0);

      const activeCount = allActiveUsers
        .filter((u: any) => u.positioning === positioning)
        .reduce((sum: number, u: any) => sum + u.count, 0);

      const total = exitCount + activeCount;
      const attritionPercentage = total > 0
        ? ((exitCount / total) * 100).toFixed(2)
        : '0.00';

      return graphType === 'pie'
        ? {
          name: positioning,
          value: exitCount,
          attritionPercentage
        }
        : {
          xAxisValueData: positioning,
          seriesValueOneData: exitCount,
          seriesValueTwoData: +attritionPercentage,
          xAxisName: '9 Box Category',
          yAxisName: 'User Count',
          seriesLabelOne: 'Exit Count',
          seriesLabelTwo: 'Attrition %',
        };
    });

    console.log("Transformed 9 Box Data:", transformedData);
    this.isNineBoxTableGraph = transformedData;

    if (chartElement) {
      if (graphType === 'pie') {
        const pieOptions = this.attritionPieChartOptions(transformedData);
        echarts.init(chartElement).setOption(pieOptions);
      } else {
        const seriesLabels = { xAxisName: '9 Box Category', yAxisName: 'User Count' };
        const graphMap: Record<string, Function> = {
          bar: this.nineBoxBarGraph,
          line: this.nineBoxLineGraph
        };

        const renderGraph = graphMap[graphType];
        if (renderGraph) {
          renderGraph.call(this, transformedData, 'ninebox-attrition-chart', 'single', seriesLabels);
        }
      }
    }
  }


  //------------------Pie Chart------------------
  attritionPieChartOptions(data: any): echarts.EChartsOption {
    return {
      tooltip: {
        trigger: 'item',
        formatter: (params: any) => {
          // console.log(params);

          // Extract all available data dynamically
          let tooltipContent = `<strong>${params.name}</strong><br/>`;
          Object.keys(params.data).forEach((key) => {
            if (key !== 'name' && key !== 'value') {
              const formattedKey = key.replace(/([A-Z])/g, ' $1').trim(); // Convert camelCase to spaced words
              tooltipContent += `${formattedKey}: <strong>${params.data[key]}</strong><br/>`;
            }
          });

          return tooltipContent;
        }
      },
      legend: {
        bottom: 0,
        formatter: (name: string) => {
          // Truncate legend names if too long
          return name.length > 12 ? name.substring(0, 12) + '...' : name;
        }
      },
      color: [
        '#5470C6', '#91CC75', '#EE6666', '#73C0DE', '#FAC858',
        '#9A60B4', '#EA7CCC', '#3BA${this.loggedInUserCompanyID}', '#FC8452', '#B4A7D6'
      ],
      series: [
        {
          name: 'Department',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: true,
            formatter: (params: any) => {
              // Truncate long names in pie slices
              const displayName = params.name.length > 17
                ? params.name.substring(0, 12) + '...'
                : params.name;
              return `${displayName}: ${params.value}`;
            }
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 14,
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: true
          },
          data: data
        }
      ],
      xAxis: { show: false },  // Hide xAxis for pie chart
      yAxis: { show: false }
    };
  }
}
